import { defineMessages } from 'react-intl';

type MessageKeys = 'highlightActionsPlaceholderPrompt';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	highlightActionsPlaceholderPrompt: {
		id: 'highlight-actions.rovo-chat.placeholder-prompt',
		defaultMessage: 'Ask a question about this.',
		description: 'Placeholder prompt for highlight actions when Chat button is clicked',
	},
});

export default message;
